import assert from 'assert';
import produce from 'immer';

import {CidIdMap} from 'notebook/notes/NoteConstants';
import {addCid} from 'notebook/store/StoreTransformUtil';
import {
  StructuredTableMapping,
  STRUCTURED_TABLE_MAPPING_CID_PREFIX,
  STRUCTURED_TABLE_COLUMN_MAPPING_CID_PREFIX,
} from 'notebook/structured-tables/structured-table-mappings/StructuredTableMappingConstants';
import {StructuredTableMappingsGlobalState} from 'notebook/structured-tables/structured-table-mappings/StructuredTableMappingsState';

/**
 * Get the StructuredTableMappings from global state and restore the ids of structured table mappings to
 * reconcile with the server
 * ⚠️ This directly mutates the provided cidIdMap
 */

export default function prepareStructuredTableMappingsForSave(
  fileId: string,
  cidIdMap: CidIdMap
): Array<StructuredTableMapping> {
  const {structuredTableMappings} = StructuredTableMappingsGlobalState.getState(fileId);
  return produce(structuredTableMappings, (draftMappings) => {
    for (const structuredTableMapping of draftMappings) {
      if (!structuredTableMapping.cid) {
        addCid(structuredTableMapping, STRUCTURED_TABLE_MAPPING_CID_PREFIX, cidIdMap);
      }
      assert(structuredTableMapping.cid, 'Structured table mapping cid is missing');
      structuredTableMapping.id = cidIdMap[structuredTableMapping.cid] as string;
      for (const columnMapping of structuredTableMapping.structuredTableColumnMappings) {
        if (!columnMapping.cid) {
          addCid(columnMapping, STRUCTURED_TABLE_COLUMN_MAPPING_CID_PREFIX, cidIdMap);
        }
        assert(columnMapping.cid, 'Structured table column mapping cid is missing');
        columnMapping.id = cidIdMap[columnMapping.cid] as string;
      }
    }
  });
}
